import { Menu, MenuButton, MenuItem, MenuList, useToast } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { useClipboard } from "@nens/react/hooks";

interface PublicationMapContextMenuProps {
  showContextMenu: boolean;
  setShowContextMenu: (arg0: boolean) => void;
  contextMenuCoords: { x: number; y: number; lat?: number; lng?: number };
  addCommentToMap: () => void;
}

export function PublicationMapContextMenu({
  showContextMenu,
  setShowContextMenu,
  contextMenuCoords,
  addCommentToMap,
}: PublicationMapContextMenuProps) {
  const intl = useIntl();
  const toast = useToast();
  const copy = useClipboard()[1];

  return (
    <Menu isOpen={showContextMenu} gutter={0} onClose={() => setShowContextMenu(false)}>
      <MenuButton
        boxSize={0}
        p={0}
        m={0}
        position="absolute"
        left={contextMenuCoords.x}
        top={contextMenuCoords.y}
        opacity={0}
        pointerEvents="none"
      />
      <MenuList fontSize={12}>
        <MenuItem
          fontWeight="medium"
          onClick={() => {
            copy(`${contextMenuCoords.lat?.toFixed(5)}, ${contextMenuCoords.lng?.toFixed(5)}`);
            toast({
              title: intl.formatMessage({
                id: "map.contextmenu.button.copied_to_clipboard.title",
                defaultMessage: "Copied to clipboard",
              }),
              description: intl.formatMessage({
                id: "map.contextmenu.button.coordinates_copied_to_clipboard.body",
                defaultMessage: "The coordinates were copied to your clipboard",
              }),
              status: "success",
              duration: 5000,
              isClosable: true,
            });
          }}
        >
          {contextMenuCoords.lat?.toFixed(4)}, {contextMenuCoords.lng?.toFixed(4)}
        </MenuItem>

        <MenuItem
          onClick={() => {
            window.open(
              `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${contextMenuCoords.lat?.toString()},${contextMenuCoords.lng?.toString()}`,
              "_blank"
            );
          }}
        >
          <FormattedMessage
            id="button.open_in_streetview"
            defaultMessage="Open in Google StreetView"
          />
        </MenuItem>

        <MenuItem onClick={addCommentToMap}>
          <FormattedMessage id="comment" defaultMessage="Place comment here" />
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
